import { render, staticRenderFns } from "./parcelConsums.vue?vue&type=template&id=b838cfde"
import script from "./parcelConsums.vue?vue&type=script&lang=js"
export * from "./parcelConsums.vue?vue&type=script&lang=js"
import style0 from "./parcelConsums.vue?vue&type=style&index=0&id=b838cfde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports